import {useEffect, useState} from "react";
import {Loading} from "./Loading";

const LifePayWidget = ({data: {email, key, comment, name, cost, on_open, on_success, on_fail, on_close, isTest}}) => {
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const s = document.head.getElementsByClassName("lifepay_script")[0];
        if (!s) {
            const s = document.createElement("script");
            s.className = "lifepay_script";
            s.onload = () => s.setAttribute("loaded", "true");
            document.head.appendChild(s);
            s.type = "text/javascript";
            s.src = "https://partner.life-pay.ru/gui/lifepay_widget/js/lp-widget.js?1234567";
        }
    }, []);

    const onClickHandle = (e) => {
        e.preventDefault();
        on_open && on_open();
        if (isTest) return on_success({test: true});
        setLoading(true);
        const s = document.head.getElementsByClassName("lifepay_script")[0];
        const interval = setInterval(() => {
            if (s.getAttribute("loaded") === "true") {
                clearInterval(interval);
                let canSuccess = true;
                let canFail = true;
                let canClose = true;
                const widget = new window.LpWidget({
                    email,
                    key, name, comment, cost,
                    on_success: () => {
                        if (canSuccess) {
                            setLoading(false);
                            canSuccess = false;
                            on_success()
                        }
                    },
                    on_fail: (e) => {
                        if (canFail) {
                            setLoading(false);
                            canFail = false;
                            on_fail(e)
                        }
                    },
                    on_close: () => {
                        if (canClose) {
                            setLoading(false);
                            canClose = false;
                            on_close()
                        }
                    },
                });
                widget.render();
            }
        });
    }

    return (
        <>
            {loading && <Loading/>}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a className="lifepay_button" href="#" onClick={onClickHandle}>
                <img
                    alt=""
                    id="a1lite_button"
                    style={{border: 0}}
                    src="https://partner.life-pay.ru/gui/images/a1lite_buttons/button_small.png"
                    title="Оплатить"
                />
            </a>
        </>
    )

}

export const LifepayButton = ({email, serviceId, recordId, isTest, cost, on_open, on_success, on_fail, on_close}) => {
    return (
        <LifePayWidget data={{
            email,
            key: "czfB5RcgiaxgiprgzH+TeQNWuM+B9rXFhb8+s5xTcsE=",
            cost,
            isTest,
            comment: serviceId + ":" + recordId,
            name: `Заказ # ${+new Date()}`,
            on_open: () => on_open?.(),
            on_success: () => on_success?.(),
            on_fail: () => on_fail?.(),
            on_close: () => on_close?.(),
        }}/>
    )
}

// https://my.life-pay.ru/company/dev
// https://home.life-pay.ru/apikeys
// https://docs.life-pay.ru/docs/api/ipsp_api_v1/life-pay-api-ecom
